import * as Actions from 'app/store/actions/initialization/initialization.actions';

const initialState = {
	entities: null,
	searchText: '',
	routeParams: {},
	selectedTab: [0],
	handleEditValues: [],
	handleModalRecover: [],
	handleModalDelete: [],
	searchMember: '',
	searchFilterCheckbox: [],
	createProjectBranch: [],
	createProjectType: [],
	createGroupType:[],
	createUserPosition:[],
	updateProjectBranch:[],
	updateProjectType:[],
	updateGroupType:[],
	updateUserPosition:[],
	deleteProjectBranch:[],
	deleteProjectType:[],
	deleteGroupType: [],
	deleteUserPosition: [],
	initializationPageClickFlag: '',
	handlingResponseInitializationPage: false,
};

const initializationReducer = (state = initialState, action) => {
	switch (action.type) {
		case Actions.MEMBER_SEARCH_TEXT: {
			return {
				...state,
				searchMember: action.searchMember,
			};
		}
		case Actions.SET_FILTER_CHECKBOX: {
			return {
				...state,
				searchFilterCheckbox: action.payload,
			};
		}
		case Actions.INITIALIZATION_GET_PROJECT_BRANCH: {
			return {
				...state,
				entities: action.payload,
				routeParams: action.routeParams
			};
		}
		case Actions.INITIALIZATION_GET_PROJECT_TYPE: {
			return {
				...state,
				entities: action.payload,
				routeParams: action.routeParams
			};
		}
		case Actions.INITIALIZATION_GET_GROUP_TYPE: {
			return {
				...state,
				entities: action.payload,
				routeParams: action.routeParams
			};
		}
		case Actions.INITIALIZATION_GET_USER_POSITION: {
			return {
				...state,
				entities: action.payload,
				routeParams: action.routeParams
			};
		}
		case Actions.SELECTED_TAB: {
			//console.log("selecteeeeeeeeeed", action)
			return {
				...state,
				entities: action.payload,
				routeParams: action.routeParams,
				selectedTab: action.tab
			};
		}
		case Actions.HANDLE_EDIT_VALUE:{
			return{
				...state,
				handleEditValues : action.payload
			}
		}
		case Actions.HANDLE_MODAL＿RECOVER:{
			return{
				...state,
				handleModalRecover : action.payload
			}
		}
		case Actions.HANDLE_MODAL＿DELETE:{
			return{
				...state,
				handleModalDelete : action.payload
			}
		}
		case Actions.INITIALIZATION_CREATE_PROJECT_BRANCH:{
			return{
				...state,
				createProjectBranch : action.payload
			}
		}
		case Actions.INITIALIZATION_CREATE_PROJECT_TYPE:{
			return{
				...state,
				createProjectType : action.payload
			}
		}
		case Actions.INITIALIZATION_CREATE_GROUP_TYPE:{
			return{
				...state,
				createGroupType : action.payload
			}
		}
		case Actions.INITIALIZATION_CREATE_USER_POSITION:{
			return{
				...state,
				createUserPosition : action.payload
			}
		}
		case Actions.INITIALIZATION_UPDATE_PROJECT_BRANCH:{
			return{
				...state,
				updateProjectBranch : action.payload
			}
		}
		case Actions.INITIALIZATION_UPDATE_PROJECT_TYPE:{
			return{
				...state,
				updateProjectType : action.payload
			}
		}
		case Actions.INITIALIZATION_UPDATE_GROUP_TYPE:{
			return{
				...state,
				updateGroupType : action.payload
			}
		}
		case Actions.INITIALIZATION_UPDATE_USER_POSITION:{
			return{
				...state,
				updateUserPosition : action.payload
			}
		}
		case Actions.INITIALIZATION_DELETE_PROJECT_BRANCH:{
			return{
				...state,
				deleteProjectBranch : action.payload
			}
		}
		case Actions.INITIALIZATION_DELETE_PROJECT_TYPE:{
			return{
				...state,
				deleteProjectType : action.payload
			}
		}
		case Actions.INITIALIZATION_DELETE_GROUP_TYPE:{
			return{
				...state,
				deleteGroupType : action.payload
			}
		}
		case Actions.INITIALIZATION_DELETE_USER_POSITION:{
			return{
				...state,
				deleteUserPosition : action.payload
			}
		}
		case Actions.INITIALIZATION_PAGE_CLICK_FLAG:{
			return{
				...state,
				initializationPageClickFlag : action.payload
			}
		}
		case Actions.HANDLING_RESPONSE_INITIALIZATION_PAGE:{
			return{
				...state,
				handlingResponseInitializationPage : action.payload
			}
		}

		default: {
			return state;
		}
	}
};

export default initializationReducer;
